import Dexie from "dexie";
import db from "../Db";

var DeleteZone = Dexie.async(function* () {
  yield db.open();
  yield db.ZONE.clear();
});

export default DeleteZone;
